import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ActionButtonsComponent } from '@shared/components/form/components/action-buttons/action-buttons.component';
import { TranslateModule } from '@ngx-translate/core';

export enum SessionWarningAction {
  EXTEND = 'EXTEND',
  LOGOUT = 'LOGOUT'
}

@Component({
  selector: 'stx-session-warning-dialog',
  templateUrl: './session-warning-dialog.component.html',
  styleUrls: ['./session-warning-dialog.component.scss'],
  imports: [ModalComponent, ActionButtonsComponent, TranslateModule]
})
export class SessionWarningDialogComponent {
  private dialogRef = inject<MatDialogRef<SessionWarningDialogComponent>>(MatDialogRef);

  onExtend(): void {
    this.dialogRef.close(SessionWarningAction.EXTEND);
  }

  onLogout(): void {
    this.dialogRef.close(SessionWarningAction.LOGOUT);
  }
}
